/* global G */
import { getRefKeys, getUrl } from '@platform/adapter/message/helper'

/**
 * Attempts to activate a draft message on the server.
 * On success, it also updates it from the adapter's
 * data and then dispatches a G.DONE event.
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 */
const fn = app => async ({ detail = {} } = {}) => {
  const eventBus = app[G.ADAPTER][G.EVENTS]
  const adapter = app[G.ADAPTER][G.MESSAGE]
  const adapterData = adapter[G.DATA]
  const item = detail?.[G.DATA]
  const callback = detail?.[G.FN]

  const adapterItem = adapterData.find(dataItem => (dataItem.key === item.key) && item.draft)

  if (item && adapterItem) {
    const sanitizedAttachment = { ...item, value: { ...item.value, attachments: undefined }, refs: getRefKeys(item.refs) }
    const url = `${getUrl(app, { key: item.key })}/default`
    const options = { middleware: ({ persistence, error }) => [persistence, error] }
    const result = await app[G.ADAPTER][G.HTTP][G.API].put({ url, params: sanitizedAttachment }, options)

    if (result) {
      delete adapterItem.draft

      adapterItem.acl = result.acl
      adapterItem._rev = result._rev
      adapterItem.refs = getRefKeys(result.refs)
      adapterItem.value = {
        ...result.value,
        attachments: adapterItem.value.attachments,
      }

      callback?.()

      eventBus.dispatch(eventBus.type(G.MESSAGE, G.DONE), { [G.DATA]: adapterData })
    }
  }
}

export default fn
